import { render, staticRenderFns } from "./farm-news.vue?vue&type=template&id=0ff7c81c&"
import script from "./farm-news.vue?vue&type=script&lang=js&"
export * from "./farm-news.vue?vue&type=script&lang=js&"
import style0 from "./farm-news.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports